export const setLoading = () => {
    return async (dispatch) => {
        await dispatch({type:"LOADING"})
    }
}